import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const SubscriptionSchedule = ()=>{
    const [subscriptionSchedule, setSubscriptionSchedule] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`subscriptionSchedule?page=${page}`);
            setSubscriptionSchedule(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`subscriptionSchedule/${id}`);
            setSubscriptionSchedule(subscriptionSchedule.filter((subscriptionSchedule) => subscriptionSchedule.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'SubscriptionSchedule'}>
            <InnerNav createLink={'/subscriptionScheduleCreate'} listLink={'/subscriptionSchedule'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Sdpservice </th>
                                    <th className="px-4 py-3">Message </th>
                                    <th className="px-4 py-3">Scheduletime </th> 
                                    <th className="px-4 py-3">Timein </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {subscriptionSchedule.map((subscriptionSchedule)=>{
                                         return(
                                             <tr key={subscriptionSchedule.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{subscriptionSchedule.id}</td>
                                                 <td className="px-4 py-3 text-sm">{subscriptionSchedule.sdp_service.service_name}</td>
                                                 <td className="px-4 py-3 text-sm">{subscriptionSchedule.message}</td>
                                                 <td className="px-4 py-3 text-sm">{subscriptionSchedule.schedule_time}</td>
                                                 
                                                 <td className="px-4 py-3 text-sm">{subscriptionSchedule.time_in}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/subscriptionSchedule/${subscriptionSchedule.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(subscriptionSchedule.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default SubscriptionSchedule;